import React, { PropsWithChildren } from 'react'
import { Contained } from '../../../components/contained/contained'
import { isNotNull, nonNull } from '../../../utils/nonNull'
import { NewsDetailProps } from '../index'
import {
  ComponentHeader,
  ComponentWrapper,
  FAQHeader,
  StyledAnchor,
  StyledHeading,
  StyledWhiteBackground,
} from '../styledNewsDetail'
import { FAQAccordions } from './accordionFAQs'
import { NewsDetailDisclaimers } from './disclaimers'
import { RelatedArticles } from './relatedArticles'

export const BelowTheFold: React.FC<PropsWithChildren<NewsDetailProps>> = (props) => {
  const { entry, carousel } = props

  if (!entry || entry.__typename !== 'news_newsEntryType_Entry') {
    return null
  }

  const { newsFaqs, newsFaqsCategory, newsDisclaimers, generalDisclaimers } = entry

  return (
    <StyledWhiteBackground>
      {newsFaqs && newsFaqs.length > 0 && (
        <ComponentWrapper>
          <Contained>
            <FAQHeader
              direction="row"
              container
              justifyContent="space-between"
              alignItems={'center'}
            >
              <StyledHeading variant={'h5'}>FREQUENTLY ASKED QUESTIONS</StyledHeading>
              {newsFaqsCategory && newsFaqsCategory[0] && (
                <StyledAnchor href={`/help-and-support/faqs?category=${newsFaqsCategory[0].id}`}>
                  {isNotNull(newsFaqsCategory[0].title) ? `View all ${newsFaqsCategory[0].title} FAQs` : 'View all FAQs'}
                </StyledAnchor>
              )}
            </FAQHeader>
            {/** @ts-ignore */}
            <FAQAccordions data={nonNull(newsFaqs)}/>
          </Contained>
        </ComponentWrapper>
      )}

      {carousel && carousel.length > 0 && (
        <ComponentWrapper>
          <ComponentHeader
            direction="row"
            container
            justifyContent="center"
          >
            <StyledHeading variant={'h5'}>RELATED ARTICLES</StyledHeading>
          </ComponentHeader>
          {/** @ts-ignore **/}
          <RelatedArticles data={nonNull(carousel)}/>
        </ComponentWrapper>
      )}
      {((newsDisclaimers && newsDisclaimers.length > 0) || (generalDisclaimers && generalDisclaimers.length > 0)) && (
        <ComponentWrapper>
          {/** @ts-ignore **/}
          <NewsDetailDisclaimers data={nonNull(newsDisclaimers)} general={nonNull(generalDisclaimers)}/>
        </ComponentWrapper>
      )}
    </StyledWhiteBackground>
  )
}